/**
 * EnergyConnect.WebApi | v1
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const WashInstruction = {
    NotSpecified: 'NotSpecified',
    NotWashable: 'NotWashable',
    Washable: 'Washable',
} as const;
export type WashInstruction = typeof WashInstruction[keyof typeof WashInstruction];

